// extracted by mini-css-extract-plugin
export default {"galleryModal":"ImageModal_galleryModal__W2ok2","modalBody":"ImageModal_modalBody__5wYHP","closeModal":"ImageModal_closeModal__OIaI8","pageOverlay":"ImageModal_pageOverlay__PbWJp"};